var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"chevron-left-a","d":"M2.87 7.118l4.178 4.442-1.058 1.12L0 6.34 5.99 0l1.058 1.12L2.87 5.562l-.68.778z"})),React.createElement("use",{"fill":"currentColor","xlinkHref":"#chevron-left-a","fillRule":"evenodd","key":1})]);
}

ChevronLeft.defaultProps = {"viewBox":"0 0 7 13","width":"7","height":"13"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
